var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { CustomFilterService } from 'path-shared/services/datasource/custom-filter-service';
import { HttpParams } from '@angular/common/http';
var defaultSortParam = 'descripcio';
var defaultSortDirection = 'asc';
var ColorsFilterService = /** @class */ (function (_super) {
    __extends(ColorsFilterService, _super);
    function ColorsFilterService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ColorsFilterService.prototype.createFilterParams = function (filter, start, pageSize, sortField, sortDir) {
        return new HttpParams()
            .append('id', (filter.id ? filter.id.toString() : ''))
            .append('descripcio', filter.descripcio)
            .append('codiPropi', filter.codiPropi)
            .append('start', start.toString())
            .append('size', pageSize.toString())
            .append('sortparam', sortField === undefined ? defaultSortParam : sortField)
            .append('sortdir', sortDir === '' ? defaultSortDirection : sortDir);
    };
    return ColorsFilterService;
}(CustomFilterService));
export { ColorsFilterService };
